<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">나의 에이지락 미 History</h2>

      <div class="rew19-search-box rew19-flex-box">
        <div class="rew19-datepicker-wrap">
          <date-picker 
            ref="reqStartDate"
            :readOnly="true"
            @update-date="updateReqStartDate" v-once></date-picker>          
          <button @click="$refs.reqStartDate.$el.focus();" type="button">달력</button>
        </div>
        <div class="rew19-datepicker-hypn">-</div>
        <div class="rew19-datepicker-wrap">
          <date-picker 
            ref="reqEndDate"
            :readOnly="true"          
            @update-date="updateReqEndDate" v-once></date-picker>          
          <button @click="$refs.reqEndDate.$el.focus();" type="button">달력</button>          
        </div>

        <div class="rew19-datepicker-btn">
          <a @click="loadList(1)" class="rew19-btn-normal">검색</a>
        </div>
      </div>

      <div class="rew19_payment_list-total">
        총<strong>{{$fmt.PDCnt(viewData.totalHistoryCount)}}</strong>개
      </div>

      <div class="rew19_payment_wrap">
        <table class="rew19-table-col">
          <caption>나의 에이지락 미 History</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="table-col__head">리워드 번호</th>
              <th class="table-col__head">
                수령인
                <span class="rew19_nextLine">(스킨케어 코드)</span>
              </th>
              <th class="table-col__head">회차</th>
              <th class="table-col__head">상태</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item) in viewData.history_list" :key="item.adr_no+item.adr_order_no"
              class="clickRow"
              @click="onClickItem(item)">
              <td class="table-col__data">{{$nvl(item.adr_no,"-")}}</td>
              <td class="table-col__data">{{$nvl(item.ship_name,"-")}}
                <span class="rew19_nextLine">({{$nvl(item.agm_code,"-")}})</span>
              </td>
              <td class="table-col__data">{{$fmt.PDCnt($nvl(item.payment_count, 0))}}</td>
              <td class="table-col__data">{{$nvl(item.status_name, "-")}}
                <span 
                  v-if="item.showRepayment"
                  class="rew19_nextLine">
                  <a @click.stop.prevent="onClickCustomProductRePayment(item)" class="rew19_btn_intable active">재결재</a>
                </span>
              </td>
            </tr>

            <tr v-if="!viewData.history_list || viewData.history_list.length <= 0">
              <td colspan="4" class="table-col__data no_data">나의 에이지락 미 리워드 프로그램 History가 없습니다.</td>
            </tr>
            
          </tbody>
        </table>
      </div>
      
      <page-nav
        ref="pageNav"
        :totalItemCount="1"
        :pageNo="1"
        :itemCountPerPage="countPerPage"
        :pageGroup="5"
        @onClickPage="onClickPage"
      ></page-nav>
    </div>
    <!--rew19_contents_inner-->

    <ageloc-repayment-dialog
      :show="agelocRepaymentDialogShow"      
      @close="agelocRepaymentClose"
      ref="agelocRepaymentDialog"
    ></ageloc-repayment-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import AgelocRepaymentDialog from '@/components/popup/AgelocRepaymentDialog';
import PageNav from "@/components/paging/pageNav";
import DatePicker from "@/components/control/DatePicker";

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

import DF from 'dateformat';

export default {
  name: "AgelocHistoryList",
  extends: AroBase,
  components: { PageNav, DatePicker, AgelocRepaymentDialog },
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  props: {
    countPerPage: {
      type: Number,
      default: 10
    },
    reqStartDate : {
      type: String,
      default : null
    },
    reqEndDate : {
      type: String,
      default : null
    }
  },
  data() { 
    return {     
      //View Data     
      viewData : {
        history_list : [
          // {
          //   adr_no : "", //key1
          //   adr_order_no :"", //key2
          // }
        ]
      },
      params : {      
        reqStartDate : this.reqStartDate,
        reqEndDate : this.reqEndDate,
        pageNo : 1
      },

      agelocRepaymentDialogShow : false,
      agelocRepaymentDialog : {},

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    {
      let endDate = new Date();
      let startDate = new Date();
      startDate.setDate(startDate.getDate()-31);
      if(!_this.params.reqStartDate){
        _this.params.reqStartDate = DF(startDate, "yyyy.mm.dd");                  
      }
      _this.$refs.reqStartDate.setDate(_this.params.reqStartDate);
      
      if(!_this.params.reqEndDate){
        _this.params.reqEndDate = DF(endDate, "yyyy.mm.dd");        
      }
      _this.$refs.reqEndDate.setDate(_this.params.reqEndDate);      
    }

    _this.initUI();
    _this.loadList(1);
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    //검색일:시작일
    updateReqStartDate(d) {
      let _this = this;
      _this.params.reqStartDate  = d;
    },

    //검색일:종료일
    updateReqEndDate(d) {
      let _this = this;
      _this.params.reqEndDate  = d;
    },
    
    /**
     * API Request
     */
    //나의 에이지락 미 히스토리 정보 가져오기
    apiGetAgelocmeHistory(reqSDate, reqEDate, pageNo){
      let _this = this;

      var reqStartDate = reqSDate.replace(/\./g, '-');
      var reqEndDate = reqEDate.replace(/\./g, '-');
      
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_history`, {
        params: {
          page : pageNo,
          countPerPage : _this.countPerPage,
          startDate: reqStartDate,
          endDate: reqEndDate,
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo){
      let _this = this;

      if(_this.params.reqStartDate >  _this.params.reqEndDate){
        _this.$dialogs.alert('날짜를 확인해주세요.');
        return false;
      }

      //init data
      _this.viewData = {
        ..._this.viewData,
        countPerPage : _this.countPerPage,
        page : 1,
        totalHistoryCount : 0,
        history_list : []
      };
      
      //show loading
      _this.$showLoading();
      _this.apiGetAgelocmeHistory(_this.params.reqStartDate, _this.params.reqEndDate, pageNo).then(res=>{
        
        if (res.status === 200 &&
          (res.data.status === "0000" || res.data.status ==="999")) {
          _this.viewData = {...res.data};

          _this.adjustListData();
                    
        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
        
        //Pass Paging info
        _this.$refs.pageNav.resetVal(
          _this.viewData.totalHistoryCount,
          _this.viewData.page,
          _this.countPerPage,
        );
      });
    },

    //데이터 후처리
    adjustListData(){
      let _this = this;
      _this.viewData.history_list = _this.viewData.history_list.map((item)=>{
        //초기값
        let retItem = {
          ...item,
          status_name : "",
          showRepayment : false,          
        };

        //상품 확인
        let existAgmCode = retItem.agm_code ? true: false;

        //결제 상태 
        //test
        //let successPaymentCheck = !("Y" == retItem.payment_check);
        let successPaymentCheck = "Y" == retItem.payment_check;

        if(existAgmCode){
          // 커스텀 프로덕트 세트
          if("Y" == retItem.adr_cancel){
            //철회된 상태
            retItem.status_name="철회";
          }else{
            //Note:테스트 코드
            //successPaymentCheck = false;
            if (successPaymentCheck) {
              //결제 완료
              retItem.status_name="결제완료";
            } else {
              retItem.status_name="결제실패";
              retItem.showRepayment = true;
            }
          }
        }else{
          // 스타트 킷트
          if("Y" == retItem.adr_cancel){
            //철회된 상태
            retItem.status_name="철회";
          }else{
            //양수 양도 확인
            if(retItem.transfer_check_message){
              retItem.status_name=_this.$nvl(retItem.transfer_check_message, "-");
            }else{
              if (successPaymentCheck) {
                //결제 완료
                retItem.status_name="결제완료";
              } else {
                retItem.status_name="결제실패";//Note:스타트 킷트는 재결제 없음.              
              }            
            }
          }
        }

        return retItem;
      });
    },

    //상세 이동
    onClickItem(item){
      let _this = this;
      let params = {
        adr_no : item.adr_no,
        adr_order_no : item.adr_order_no,
        reqStartDate : _this.params.reqStartDate,
        reqEndDate : _this.params.reqEndDate,
      };
      let qs = require('qs').stringify(params, {arrayFormat: 'brackets'});

      _this.$router.push(`${_this.$aroBasePath}/agelocHistoryDetail?${qs}`);
    },

    //페이지 이동
    onClickPage(pageNo){
      let _this = this;

      _this.loadList(pageNo);
    },

    //재결제
    onClickCustomProductRePayment(item){
      let _this = this;

      //재결제를 위한 Dialog open
      _this.agelocRepaymentDialog = {        
        adr_no : item.adr_no,
        adr_order_no : item.adr_order_no,
        payment_target : item.payment_target,
        payment_typ : item.payment_typ,
      };
      _this.$refs.agelocRepaymentDialog.initData(_this.agelocRepaymentDialog);
      _this.agelocRepaymentDialogShow = true;  
    },

    //재결제 Popup close
    agelocRepaymentClose(isOk, data){
      let _this = this;

      _this.agelocRepaymentDialogShow = false;      

      if(!isOk){
        //Do nothing
        return;
      }

      //해당페이지 리로딩
      _this.loadList(_this.viewData.page);
    },
  }
}
</script>
<style>
tr.clickRow, a.rew19-btn-normal, a.rew19_btn_intable{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/historyList.vue